export const getTestCaseSourceLabel = (source) => {
  switch (source) {
    case 'ui_exploration':
    case 'enhanced_exploration':
      return 'UI Explorer';
    case 'prd_generation':
      return 'PRD';
    case 'ai_generation':
    case 'AI_GENERATED':
      return 'AI Generated';
    case 'manual':
    case 'uploaded':
    case 'excel_upload':
    case 'csv_upload':
      return 'Uploaded';
    case 'jira':
      return 'JIRA';
    case 'confluence':
      return 'Confluence';
    case 'regression_completion':
      return 'Regression Coverage';
    default:
      return 'Unknown';
  }
};

export const getTestCaseStoryLabel = (testCase = {}) => {
  const meta = testCase.meta || {};
  if (meta.story_key) return meta.story_key;
  if (testCase.story_key) return testCase.story_key;
  if (testCase.source === 'regression_completion' && meta.source_pkb_entry_key) {
    return meta.source_pkb_entry_key;
  }
  return null;
};
